import React from 'react';
import { getStatusColor, getStatusIcon, formatStatusLabel } from '../../constants/statusConstants';
import styles from './StatusBadge.module.scss';

const StatusBadge = React.memo(({ status, showIcon = false }) => (
  <span className={`badge badge-${getStatusColor(status)} ${styles.badge}`}>
    {showIcon && `${getStatusIcon(status)} `}
    {formatStatusLabel(status)}
  </span>
));

StatusBadge.displayName = 'StatusBadge';

export default StatusBadge;
